"use client"

import { useI18n } from "@/lib/i18n/context"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { Globe } from "lucide-react"
import { localeNames, locales, type Locale } from "@/lib/i18n/config"
import { useRouter } from "next/navigation"

export function LanguageSelector() {
    const { locale } = useI18n()
    const router = useRouter()

    const handleChange = (newLocale: Locale) => {
        // Set cookie
        document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000; SameSite=Lax`
        // Reload to apply changes server-side
        router.refresh()
        // Explicit window reload might be needed to reset any client state full
        window.location.reload()
    }

    return (
        <div className="flex items-center gap-2">
            <Globe className="h-4 w-4 text-gray-400" />
            <Select value={locale} onValueChange={(val) => handleChange(val as Locale)}>
                <SelectTrigger className="h-8 w-[140px] border-gray-700 bg-gray-800 text-xs text-gray-300 focus:ring-gray-700">
                    <SelectValue placeholder="Idioma" />
                </SelectTrigger>
                <SelectContent>
                    {locales.map((l) => (
                        <SelectItem key={l} value={l}>
                            {localeNames[l]}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    )
}
